import { gql } from '@apollo/client';
/**
 * Clients for a select: only the id and the name. ClientsQuery loads the full
 * fragment (contacts, locations…) of every client.
 * @const ClientOptionsQuery
 * @since 1.0.0
 */
export const ClientOptionsQuery = gql `
  query ClientOptionsQuery($input: ClientsInput) {
    clients(input: $input) {
      items {
        id
        name
      }
    }
  }
`;
